/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Description_Export_Failed_ToastInputs */

const en_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error exporting audio description. ${i?.error}`)
};

const fr_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de l'exportation de la description audio. ${i?.error}`)
};

const de_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Exportieren der Audiobeschreibung. ${i?.error}`)
};

const it_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'esportazione della descrizione audio. ${i?.error}`)
};

const ru_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при экспорте аудиоописания. ${i?.error}`)
};

const es_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al exportar la descripción del audio. ${i?.error}`)
};

const zh_cn2_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出音频描述时出错。${i?.error}`)
};

const ja_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音声説明のエクスポート中にエラーが発生しました。${i?.error}`)
};

const hi_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण निर्यात करने में त्रुटि। ${i?.error}`)
};

const pt_pt2_audio_description_export_failed_toast = /** @type {(inputs: Audio_Description_Export_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao exportar a descrição de áudio. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error exporting audio description. {error}" |
*
* @param {Audio_Description_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_failed_toast = /** @type {((inputs: Audio_Description_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_failed_toast(inputs)
	if (locale === "de") return de_audio_description_export_failed_toast(inputs)
	if (locale === "it") return it_audio_description_export_failed_toast(inputs)
	if (locale === "ru") return ru_audio_description_export_failed_toast(inputs)
	if (locale === "es") return es_audio_description_export_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_failed_toast(inputs)
	if (locale === "ja") return ja_audio_description_export_failed_toast(inputs)
	if (locale === "hi") return hi_audio_description_export_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_failed_toast(inputs)
	return en_audio_description_export_failed_toast(inputs)
});